
  /* eslint-disable */
  import axios from "axios";
  import store from "../../store/index";
  import auth0 from "auth0-js";
  //import Multiselect from 'vue-multiselect'
  import Multiselect from "@vueform/multiselect";
  export default {
    name: "raiseQuery",
    components: { Multiselect },
  
    props: {  
      subjectCode:{
        type:String,
        default:""
      },
      siteCode:{
        type:String,
        default:""
      },
      siteId:{
        type:String,
        default:""
      },
      subjectId:{
        type:String,
        default:""
      },
      visitName:{
        type:String,
        default:""
      },
      fieldname:{
        type:String,
        default:""
      }
     },
    data() {
      return {
        chksendmail: "",
        options: {
          isChecked: "",
        },
        baseUrl: process.env.VUE_APP_Service_URL,
        checkboxclick: false,
        values: {
          studyId: "",
          siteId: "",
          FieldName: "",
          formName: "",
          Subject: "",
          Message: "",
          Sender: "",
          Priority: "",
          Recipients: [],
          PageNo: 0,
          PageName: "",
          QueryFor: "",
        },
        formId: "",
        feilName: "",
        formData: "",
        arrayofdata: [],
        recipients: [],
        subject: "",
        site: "",
        userName: "",
        errors: [false, false, false, false],
        newModel: {
          fullNAme: "",
          email: "",
        },
        listNewModel: [],
        roleList: [],
        multiRoleSelectList: [],
        emailrecipients: [],
        selectedemailrecipients: [],
        passstudyname: "",
      };
    },
    async mounted() {
      window.addEventListener("studyIdChanged", (event) => {
        //  console.log("StudyIDChanged into" + event.detail.storage);
        // window.location.reload();
        this.getUserName();
        this.GetFormData();
        // this.getPatient(this.formData.subjectId);
        // this.getSites(this.formData.siteId);
        this.setRoleList();
        this.getStudyname();
        // this.getRecipients();
        this.values.studyId = store.getters.getStudyIs;
      });
      await this.getStudyname();
      await this.getUserName();
      await this.GetFormData();
      // await this.getPatient(this.formData.subjectId);
      // await this.getSites(this.formData.siteId);
   // await this.getRecipients();
      await this.setRoleList();
      this.values.studyId = store.getters.getStudyIs;
    },
    methods: {
      closeModal(){
        this.$emit("closeModal")
      },
      async CreateQuery() {
        await this.validateIsNull();
        if (
          !this.errors[0] &&
          !this.errors[1] &&
          !this.errors[2] &&
          !this.errors[3]
        ) {
          await this.getselectedemailrecepients();
          const idtoken = store.getters.getIdToken;
          //  console.log("id token is ", idtoken);
          await axios
            .post(
              `${this.baseUrl}/forms/query/create`,
              {
                queryId: "",
                formId: "",
                studyId: store.getters.getStudyIs,
                folderId: "",
                siteId: this.siteId,
                subjectId: this.subjectId,
                visitId: this.visitId,
                visitName: this.visitName,
                queryFor: "FHIR",
                query_Subject: this.values.Subject,
                priority:
                  this.values.Priority == "" ? "Low" : this.values.Priority,
                pageNo: 0,
                fieldName: this.fieldname,
                queryOpenStatus: "true",
                queryResponseStatus: true,
                closeBy: "",
                emailRecepients: this.selectedemailrecipients,
                sitecode: this.siteCode,
                formname: "Observation",
                pagename: "",
                patientid: this.subjectCode,
                studyname: "",
                queryOrigin: "Manual",
                messages: [
                  {
                    queryMessage: this.values.Message,
                    raisedBy: this.values.Sender,
                    raisedDate: new Date().toISOString(),
                    messagesRecipients: [
                      {
                        recipients: this.values.Recipients,
                      },
                    ],
                  },
                ],
              },
              {
                headers: {
                  Authorization: "Bearer " + idtoken,
                  "Content-Type": "application/json",
                },
              }
            )
            .then((res) => {
              console.log("create Query ", idtoken);
              alert(this.$t("navigations.query raised successfully"));
              this.$emit("closeModal")
            })
            .catch((err) => console.log("error", err));
        }
      },
      async ClearData() {
        (this.chksendmail = ""), (this.checkboxclick = false);
        (this.multiRoleSelectList = []),
        await this.onroleClosed(),
        (this.values = {
          FieldName: "",
          formName: "",
          Subject: "",
          Message: "",
          Sender: "",
          Priority: "",
          Recipients: [],
          PageNo: 0,
          QueryFor: "",
        });
  
      },
      async getStudyname() {
        const studyname = store.getters.getStudyIs;
        const idtoken = store.getters.getIdToken;
        console.log("form passing studyanme .......", studyname);
        await axios
          .get(
            `${this.baseUrl}/management/study/getbyid?id=${studyname}&api-version=1.0`,
            {
              headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
              },
            }
          )
          .then((res) => {
            this.passstudyname = res.data.studyName;
            console.log("form data .......", this.passstudyname);
          })
          .catch((err) => {
            console.log(err);
          });
      },
      async onclosed() {
        //this.$router.push(`/showform/forms/` + this.arrayofdata[0]);
         const archive = false;
          this.$router.push(`/showform/forms/` + this.arrayofdata[0] + "/" + archive);
      },
      async GetFormData() {
        const idtoken = store.getters.getIdToken;
        console.log(idtoken);
        await axios
          .get(`${this.baseUrl}/forms/forms/getbyid/` + this.arrayofdata[0], {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          })
          .then((res) => {
            this.formData = res.data;
            //  console.log("form data .......", res.data);
          })
          .catch((err) => {
            console.log(err);
          });
      },
      async getPatient(patientId) {
        const idtoken = store.getters.getIdToken;
        await axios
          .get(`${this.baseUrl}/management/patient/getpatientbyid/` + patientId, {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          })
          .then((res) => (this.subject = res.data))
          .catch((err) => console.log(err));
      },
      async getSites(siteId) {
        const idtoken = store.getters.getIdToken;
        await axios
          .get(`${this.baseUrl}/management/site/getbyid?id=` + siteId, {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          })
          .then((res) => (this.site = res.data))
          .catch((err) => console.log(err));
      },
      async jwtDecrypt(token) {
        const base64Url = token.split(".")[1];
        const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        const jsonPayload = decodeURIComponent(
          atob(base64)
            .split("")
            .map(function (c) {
              return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join("")
        );
        return JSON.parse(jsonPayload);
      },
      async getUserName() {
        const idToken = store.getters.getIdToken;
        const jwtDecodedValue = await this.jwtDecrypt(idToken);
        this.userName = jwtDecodedValue.name;
        //  console.log("token result", this.userName);
      },
      async validateIsNull() {
        if (this.values.Subject == "") {
          this.errors[0] = true;
        } else {
          this.errors[0] = false;
        }
  
        if (this.values.Message == "") {
          this.errors[1] = true;
        } else {
          this.errors[1] = false;
        }
  
        if (this.values.Recipients == "") {
          this.errors[2] = true;
        } else {
          this.errors[2] = false;
        }
  
        if (this.multiRoleSelectList == "") {
          this.errors[3] = true;
        } else {
          this.errors[3] = false;
        }
      },
      async getUserName() {
        const idToken = store.getters.getIdToken;
        const jwtDecodedValue = await this.jwtDecrypt(idToken);
        this.userName = jwtDecodedValue.name;
        console.log("token result", this.userName);
      },
      async setRoleList() {
        //  console.log("roles here.");
        const idtoken = store.getters.getIdToken;
        await axios
          .get(`${this.baseUrl}/account-core/roles/rolelist`, {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          })
          .then((res) => {
            this.roleList = res.data;
            console.log("roles are..", this.roleList);
          });
      },
      async onroleClosed() {
        this.emailrecipients.splice(0);
        this.recipients.splice(0);
        this.values.Recipients.splice(0);
        //  console.log("dClosEd",this.multiRoleSelectList);
        await this.getrolebasedrecepients();
      },
      async onRecipientsClosed() {
        this.selectedemailrecipients.splice(0);
         this.values.Recipients.forEach((recipient) => {
          const exists = this.emailrecipients.find((emailRecipient) => emailRecipient.evalu === recipient);
          if (!exists) {
            let eusers = {
              id: String,
              evalu: String,
              isChecked: Boolean,
            };
            eusers.evalu = recipient;
            eusers.isChecked=true;
            this.emailrecipients.push(eusers);
          }
        });
         this.emailrecipients.forEach((emailRecipient) => {
          const exists = this.values.Recipients.find((recipient) => emailRecipient.evalu === recipient);
          if (!exists) {
            const index = this.emailrecipients.indexOf(emailRecipient);
            this.emailrecipients.splice(index,1);
          }
        });
      },
  
      async closebtnclicked() {
        this.emailrecipients.splice(0);
        this.recipients.splice(0);
        this.values.Recipients.splice(0);
      },
      async recepientclosebtnclicked() {
        console.log("RECP CLOSED", this.multiRoleSelectList);
        this.emailrecipients.splice(0);
      },
  
      async getrolebasedrecepients() {
        console.log("In get role based recipients");
        const valnow = await store.getters.getStudyIs;
        const idtoken = store.getters.getIdToken;
        var rcount = this.multiRoleSelectList.length;
        if (rcount > 0) {
          var fullroleids = "";
          for (var i = 0; i < rcount; i++) {
            fullroleids = fullroleids + this.multiRoleSelectList[i] + ",";
          }
          console.log("formdata", this.formData.siteId);
          await axios
            .get(
              // `https://localhost:5001/user/getusersbyrole?roleids=`+fullroleids+`&&studyid=`+valnow,{
              `${this.baseUrl}/account-core/user/getusersbyrole?roleids=` +
                fullroleids +
                `&studyid=` +
                valnow +
                `&siteId=` +
                this.formData.siteId,
              {
                headers: {
                  Authorization: "Bearer " + idtoken,
                  "Content-Type": "application/json",
                },
              }
            )
            .then((res) => {
              console.log("recipients list is ..", this.recipients);
              this.recipients = [];
              res.data.forEach((element) => {
                if (element.email != this.userName) {
                  this.recipients.push(element);
                }
              });
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          this.recipients = [];
        }
      },
  
       async check(){
          console.log("is check clicked",this.checkboxclick)  
                if(this.checkboxclick)
                { 
                  this.checkboxclick =false;
                  this.emailrecipients = [];
                }else{  
                    this.checkboxclick =true;
                    this.emailrecipients = [];
                    this.values.Recipients.forEach((element) => {
                      let eusers = {
                        id: String,
                        evalu: String,
                        isChecked: Boolean,
                      };
                    
                        eusers.evalu = element;
                        eusers.isChecked=true;
                        this.emailrecipients.push(eusers);
                      
                    });
                }
            
       },
      async getselectedemailrecepients() {
        if (this.checkboxclick == true) {
          //this.selectedemailrecipients =this.emailrecipients.check;
          this.emailrecipients.forEach((element) => {
            if (element.isChecked) {
              console.log("BFREselectedemailrecipients", element);
              this.selectedemailrecipients.push(element.evalu);
            }
          });
        } else {
          console.log("Unchecked!");
        }
        console.log("selectedemailrecipients", this.selectedemailrecipients);
      },
    },
  };
